(() => {
const C = window.JoffzProductConfigurator;
if (!C) return;
Object.assign(C.prototype, {
bindEvents() {
const listenerOptions = { signal: this.signal };
this.materialInputs.forEach((input) => {
input.addEventListener('change', (event) => this.onMaterialChange(event), listenerOptions);
});
this.frameInputs.forEach((input) => {
input.addEventListener('change', (event) => this.onFrameChange(event), listenerOptions);
});
this.mountInputs.forEach((input) => {
input.addEventListener('change', (event) => this.onMountChange(event), listenerOptions);
});
this.sizeInputs.forEach((input) => {
input.addEventListener('change', (event) => this.onSizeChange(event), listenerOptions);
});
this.addEventListener('change', (event) => {
const control = event.target?.closest?.('[data-jpc-material], [data-jpc-frame], [data-jpc-mount], [data-jpc-size]');
if (!control || control.disabled) return;
this.queuePreviewReveal();
}, listenerOptions);
this.variantSelect.addEventListener('change', () => {
if (this.isSyncingNativeSelect) return;
const variant = this.variantById.get(String(this.variantSelect.value));
if (variant) this.applyVariant(variant, { updateHistory: true, announce: true });
}, listenerOptions);
this.quantityMinus?.addEventListener('click', () => this.adjustQuantity(-1), listenerOptions);
this.quantityPlus?.addEventListener('click', () => this.adjustQuantity(1), listenerOptions);
this.quantityInput?.addEventListener('change', () => this.sanitizeQuantity(), listenerOptions);
this.quantityInput?.addEventListener('blur', () => this.sanitizeQuantity(), listenerOptions);
this.sizeGuideOpen?.addEventListener('click', () => this.openSizeGuide(), listenerOptions);
this.sizeGuideClose?.addEventListener('click', () => this.closeSizeGuide(), listenerOptions);
this.sizeDialog?.addEventListener('click', (event) => {
if (event.target === this.sizeDialog) this.closeSizeGuide();
}, listenerOptions);
window.addEventListener('popstate', () => this.restoreFromUrl(), listenerOptions);
},
queuePreviewReveal() {
if (!window.matchMedia?.('(max-width: 989px)').matches) return;
const stage = this.querySelector('.jpc-stage');
if (!stage) return;
clearTimeout(this.previewRevealTimer);
this.previewRevealTimer = window.setTimeout(() => {
if (!stage.isConnected) return;
const rect = stage.getBoundingClientRect();
const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
const visibleTop = Math.max(0, rect.top);
const visibleBottom = Math.min(viewportHeight, rect.bottom);
const visibleHeight = Math.max(0, visibleBottom - visibleTop);
const visibleRatio = rect.height > 0 ? visibleHeight / Math.min(rect.height, viewportHeight || rect.height) : 0;
const shouldScroll = visibleRatio < 0.68 || rect.top < 56;
const behavior = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
if (shouldScroll) stage.scrollIntoView({ behavior, block: 'start', inline: 'nearest' });
stage.classList.remove('jpc-preview-focus-pulse');
requestAnimationFrame(() => stage.classList.add('jpc-preview-focus-pulse'));
window.setTimeout(() => stage.classList.remove('jpc-preview-focus-pulse'), 620);
}, 90);
},
configureStaticAvailability() {
this.frameInputs.forEach((input) => {
const isPermanent = input.hasAttribute('disabled') && Boolean(input.dataset.disabledReason);
input.dataset.permanentlyDisabled = isPermanent ? 'true' : 'false';
if (isPermanent) return;
const nativeFinish = input.dataset.nativeFinish;
const exists = this.variants.some(
(variant) => this.normalize(variant.options[this.finishOptionKey]) === this.normalize(nativeFinish)
);
input.disabled = !exists;
});
this.materialInputs.forEach((input) => {
const scopedFrames = this.frameInputs.filter(
(frameInput) => frameInput.dataset.materialScope === input.value
);
input.disabled = !scopedFrames.some((frameInput) => !frameInput.disabled);
});
},
restoreInitialState() {
const urlVariantId = new URL(window.location.href).searchParams.get('variant');
const liquidVariantId = this.dataset.currentVariantId;
const selectVariantId = this.variantSelect.value;
const initialVariant =
this.variantById.get(String(urlVariantId || '')) ||
this.variantById.get(String(liquidVariantId || '')) ||
this.variantById.get(String(selectVariantId || '')) ||
this.variants.find((variant) => variant.available) ||
this.variants[0];
this.applyVariant(initialVariant, {
updateHistory: true,
replaceHistory: true,
announce: false,
});
},
restoreFromUrl() {
const variantId = new URL(window.location.href).searchParams.get('variant');
const variant = this.variantById.get(String(variantId || ''));
if (!variant) return;
this.isRestoringHistory = true;
this.applyVariant(variant, { updateHistory: false, announce: true });
this.isRestoringHistory = false;
},
onMaterialChange(event) {
const material = event.currentTarget.value;
if (event.currentTarget.disabled) return;
const desiredFrame = material === 'canvas' ? this.lastCanvasFrame : this.lastPaperFrame;
const selectedFrame = this.findUsableFrameInput(material, desiredFrame) || this.findUsableFrameInput(material);
if (!selectedFrame) {
this.renderUnavailable(this.labels.unavailable || this.dataset.messageUnavailable);
return;
}
selectedFrame.checked = true;
if (material === 'canvas') {
this.lastCanvasFrame = selectedFrame.value;
this.setMount('no');
} else {
this.lastPaperFrame = selectedFrame.value;
this.setMount(this.lastPaperMount);
}
this.updateControlVisibility(material, selectedFrame.value);
this.resolveFromControls({ updateHistory: true, announce: true, allowClosestSize: true });
},
onFrameChange(event) {
const input = event.currentTarget;
if (input.disabled) return;
const material = input.dataset.materialScope || this.getSelectedMaterial();
if (material === 'canvas') {
this.lastCanvasFrame = input.value;
this.setMount('no');
} else {
this.lastPaperFrame = input.value;
}
this.updateControlVisibility(material, input.value);
this.resolveFromControls({ updateHistory: true, announce: true, allowClosestSize: true });
},
onMountChange(event) {
const input = event.currentTarget;
if (input.disabled) return;
this.lastPaperMount = input.value;
this.resolveFromControls({ updateHistory: true, announce: true, allowClosestSize: false });
},
onSizeChange(event) {
if (event.currentTarget.disabled) return;
this.resolveFromControls({ updateHistory: true, announce: true, allowClosestSize: false });
}
});
})();
